var React = require('react');

function ChevronDownBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m28 9 4 5h-8z","fillRule":"evenodd","transform":"matrix(-1 0 0 -1 32 14)"}));
}

ChevronDownBlackInline.defaultProps = {"height":"5","viewBox":"0 0 8 5","width":"8"};

module.exports = ChevronDownBlackInline;

ChevronDownBlackInline.default = ChevronDownBlackInline;
